<template>
<div class="top">
    <img src="@/assets/images/cec2022/top_lan.png"/>
    <div class="navigate">
        <img src="@/assets/images/cec2022/left_arrow.png" class="icon left-icon" @click="goBack()"/>
        <span>{{title}}</span>
        <img src="@/assets/images/cec2022/nav_button.png" class="icon right-icon" @click="show=true"/>
    </div>
    <van-popup v-model="show" position="right" :style="{ width: '160px',height:'100%' }">
        <div class="nav">
            <p @click="skip(0)">回到首页</p>
            <p @click="skip(1)">会议信息</p>
            <p @click="skip(2)">日程一览</p>
            <p @click="skip(3)">专家检索</p>
            <p @click="skip(4)">我的任务</p>
            <p @click="skip(5)">网络直播</p>
            <p @click="skip(6)">企业会议</p>
            <p @click="skip(7)">VR展厅</p>
            <p @click="skip(8)">电子壁报</p>
            <p @click="skip(9)">个人中心</p>
            <p @click="skip(10)">下载中心</p>
            <p @click="skip(11)">联系我们</p>
        </div>
    </van-popup>
</div>
</template>

<script>
export default {
    props:{
        title:String
    },
    data(){
        return{
            show:false
        }
    },
    methods:{
        goBack(){
            this.$router.go(-1);
        },
        skip(type){
            switch(type){
                case 0:
                    this.$router.push('/cec2022/index');
                    break;
                case 1:
                    this.$router.push('/cec2022/info?button_id=806');
                    break;
                case 2:
                    this.$router.push('/cec2022/schedule?id=286&button_id=808')
                    break;
                case 3:
                    this.$router.push('/vascularnews/expert/search?meeting_id=286&button_id=810')
                    break;
                case 4:
                    this.$router.push('/vascularNews/personal/taskbookDetail?meeting_id=286&button_id=811')
                    break;
                case 5:
                    this.$router.push('/vascularNews/meeting/live?meeting_id=286&button_id=809')
                    break;
                case 6:
                    this.$router.push('/vascularNews/exhibition?meeting_id=286')
                    break;
                case 7:
                    this.$router.push('/cec2022/coming?meeting_id=286')
                    break;
                case 8:
                    window.location.href='http://bbh5.imjiayi.com/'
                    break;
                case 9:
                     this.$router.push('/cec2022/personal');
                    break;
                case 10:
                    this.$router.push('/cec2022/download');
                    break;
                case 11:
                    this.$router.push('/cec2022/contact');
                    break;
            }
        }
    }
}
</script>

<style scoped>
.top{
	position: fixed;
    z-index: 100;
    height: 48px;
    top: 0;
    left: 0;
    right: 0;
	color: white;
    margin: auto;
    max-width: 11rem;
}
.top img{
	width: 100%;
	height: 48px;
	display: block;
}
.top .navigate{
	position: absolute;
	top: 0;
	left: 0;
	vertical-align: middle;
	line-height: 48px;
	font-size: 18px;
	width: 100%;
    height: 100%;
}
.top .navigate .icon{
	display: inline-block;
	vertical-align: middle;
}
.top .navigate .left-icon{
	height: 20px;
	width: auto;
	margin-right: 5px;
	margin-left: 20px;
	margin-bottom: 5px;
}
.top .navigate .right-icon{
	height: 16px;
	width: auto;
	float: right;
	margin: 16px;
}
.nav{
    color: #B2312E;
    font-size: 18px;
    line-height: 60px;
}
.nav p{
    text-align: center;
    border-bottom: solid 1px #f5f4f4;

}
</style>


// WEBPACK FOOTER //
// src/pages/cec2022/component/topNav.vue